const ASC = 'asc'
const DESC = 'desc'
const SORTING_DIRECTION_OPTIONS = [ASC, DESC]

export default {
  ASC,
  DESC,
  SORTING_DIRECTION_OPTIONS
}
